<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/trainingrequest.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("training_request") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb
      v-if="!editMode"
      :viewTrainingRequest="
        $user && $rights && $rights.includes('VIEW_TRAINING_REQUESTS')
      "
    />
    <Breadcrumb
      v-else
      :trainingNameEdit="'R' + request.id"
      :viewTrainingRequest="
        $user && $rights && $rights.includes('VIEW_TRAINING_REQUESTS')
      "
    />
    <div class="pt-8">
      <div class="row disablerow align-items-start">
        <!-- Tabs -->
        <v-tabs
          v-model="trainingRequestTab"
          align-with-title
          v-show="editMode"
          touchless
          class="LanguageselectTabgroup LanguageselectTabgroup-1 pt-md-4 pt-lg-0 pl-md-8 pl-4"
        >
          <v-tabs-slider color="indigo"></v-tabs-slider>

          <v-tab class="LanguageselectTab LanguageselectTab-1">
            <span class="langauge-text-slider">{{
              $t("training_request")
            }}</span>
          </v-tab>
          <v-tab
            class="LanguageselectTab LanguageselectTab-2"
            v-if="
              $rights.includes('VIEW_TRAINING_EVENT') &&
              $user &&
              !$user.onlySalesPerson
            "
          >
            <span class="langauge-text-slider">{{ $t("trainingevents") }}</span>
          </v-tab>
        </v-tabs>

        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining innercreatetraining-1">
          <div class="px-md-4 mx-0 pa-0 text-content">
            <v-tabs-items v-model="trainingRequestTab" touchless>
              <!-- Tab for Editing Training Request -->
              <v-tab-item>
                <div
                  class="row disablerow justify-content-between main-training-request-wrap"
                >
                  <div class="col-md-12 row disablerow align-items-start">
                    <div class="col-md-12 pt-0 margin-wrapper">
                      <span class="headlinecolor formheading">
                        {{ $t("Training_Course") }}</span
                      >
                    </div>
                    <div class="col-md-12 row disablerow">
                      <div class="col-md-12 pt-0 pb-0 mb-6">
                        <p v-html="$t('training_course_choose_from')"></p>
                        <p v-html="$t('desired_tarning_is_not_listing')"></p>
                        <p v-html="$t('contact_us_using_details')"></p>
                      </div>
                      <div class="col-md-6 my-btn">
                        <v-tooltip slot="append" bottom attach=".my-btn">
                          <template v-slot:activator="{ on, attrs }">
                            <v-autocomplete
                              v-model="request.eventTrainingCategoryId"
                              hide-details="auto"
                              class="datainput justify-content-end searchbar align-self-center pb-1"
                              :items="trainingEventCategories1"
                              item-text="text"
                              item-value="value"
                              style="padding-right: 2px"
                              dense
                              outlined
                              clearable
                              v-bind="attrs"
                              v-on="on"
                              :label="$t('training_event_category') + '*'"
                              @change="disableTraining()"
                              :disabled="trainingCategoryDisabled"
                            >
                            </v-autocomplete>
                          </template>
                          <span>{{
                            $t("trainingEvent_trainingCourse_OtherTraining")
                          }}</span>
                        </v-tooltip>
                      </div>

                      <div class="col-md-6 my-btn3">
                        <v-tooltip slot="append" bottom attach=".my-btn3">
                          <template v-slot:activator="{ on, attrs }">
                            <v-autocomplete
                              v-model="request.trainingId"
                              hide-details="auto"
                              class="datainput justify-content-end searchbar align-self-center pb-1"
                              :items="sortedTrainings"
                              item-text="text"
                              item-value="value"
                              style="padding-right: 2px"
                              dense
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              clearable
                              :label="$t('training') + '*'"
                              :disabled="trainingDisabled"
                              @change="disableTrainingEventCategory()"
                            >
                            </v-autocomplete>
                          </template>
                          <span>{{
                            $t("trainingEvent_trainingCourse_OtherTraining")
                          }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                    <div class="col-md-12 row disablerow">
                      <div
                        v-if="
                          filteredCategories &&
                          filteredCategories.length > 0 &&
                          showCategory
                        "
                        class="col-md-6 pt-0"
                      >
                        <p class="training-category-lebel">
                          {{ $t("category") }}
                        </p>
                        <div class="list-component list-componant-wrapper">
                          <v-list class="v-list-flex v-list_custom">
                            <v-list-item
                              class="v-list-item-wrap"
                              v-for="cat in filteredCategories"
                              :key="cat.value"
                            >
                              <v-list-item-content>
                                {{ cat.text }}
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </div>
                      </div>
                      <div class="col-md-6 my-btn2">
                        <v-tooltip slot="append" bottom attach=".my-btn2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              hide-details="auto"
                              class="datainput justify-content-end align-self-center pb-1"
                              dense
                              outlined
                              :label="$t('other_training')"
                              v-model="request.otherTraining"
                              v-bind="attrs"
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <span>{{ $t("other_tooltip_msg") }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-12 row disablerow align-items-start C-I-wrapper"
                  >
                    <div class="col-md-12 pt-0 margin-wrapper">
                      <span class="headlinecolor formheading">
                        {{ $t("customer_information") }}</span
                      >
                    </div>
                    <div class="col-md-6 row disablerow">
                      <div class="col-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('firstname') + '*'"
                          v-model="request.firstname"
                        ></v-text-field>
                      </div>
                      <div class="col-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('lastname') + '*'"
                          v-model="request.lastname"
                        ></v-text-field>
                      </div>
                      <div class="col-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('phone') + '*'"
                          v-model="request.phone"
                        ></v-text-field>
                      </div>
                      <div class="col-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('email') + '*'"
                          v-model="request.email"
                          :rules="[emailValidationRule]"
                        ></v-text-field>
                      </div>

                      <div class="col-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('customerNumber')"
                          v-model="request.customerNumber"
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="col-md-6 row disablerow">
                      <div class="col-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('company') + '*'"
                          v-model="request.customerName"
                        ></v-text-field>
                      </div>
                      <div class="col-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('customer_location') + '*'"
                          v-model="request.customerLocation"
                        ></v-text-field>
                      </div>
                      <div class="col-sm-8 col-md-9 pr-sm-0">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('street') + '*'"
                          v-model="request.street"
                        ></v-text-field>
                      </div>
                      <div class="col-sm-4 col-md-3">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('number') + '*'"
                          v-model="request.hnr"
                        ></v-text-field>
                      </div>
                      <div class="col-sm-4 col-md-3 pr-sm-0">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('postal code') + '*'"
                          v-model="request.zip"
                        ></v-text-field>
                      </div>
                      <div class="col-sm-8 col-md-9">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('location') + '*'"
                          v-model="request.city"
                        ></v-text-field>
                      </div>
                      <div class="col-sm-12 col-md-12">
                        <v-select
                          hide-details="auto"
                          :items="sortedCountries"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('country') + '*'"
                          v-model="request.country"
                        ></v-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 row disablerow C-I-wrapper">
                    <div class="col-md-12 pt-0 margin-wrapper">
                      <span class="headlinecolor formheading">
                        {{ $t("training_event") }}</span
                      >
                    </div>
                    <div class="col-12 tce-document-wrap">
                      {{ $t("documents in") + "*" }}
                      <v-radio-group
                        v-model="request.documentType"
                        dense
                        class="justify-content-end align-self-center"
                      >
                        <v-radio
                          :key="'online'"
                          :label="$t('online_documents')"
                          :value="'ONLINE'"
                        ></v-radio>

                        <v-radio
                          :key="'usb'"
                          :label="$t('USBform') + $t('printedSetusb')"
                          :value="'USB'"
                        ></v-radio>

                        <v-radio
                          :key="'print'"
                          :label="$t('printedForm') + $t('printedSet')"
                          :value="'PRINT'"
                        >
                        </v-radio>
                      </v-radio-group>
                    </div>
                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('contactPerson') + '*'"
                        v-model="request.contactPerson"
                      ></v-text-field>
                    </div>

                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('training_location') + '*'"
                        v-model="request.location"
                      ></v-text-field>
                    </div>

                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('available_infrastructure')"
                        :hint="$t('available_infrastructure_hint')"
                        v-model="request.infrastructure"
                      ></v-text-field>
                    </div>

                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        type="number"
                        min="1"
                        outlined
                        :label="$t('participantsAmount') + '*'"
                        v-model="request.participantsAmount"
                      ></v-text-field>
                    </div>

                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('participantQualification') + '*'"
                        v-model="request.participantQualification"
                      ></v-text-field>
                    </div>

                    <div class="col-md-12 pb-4">
                      <v-textarea
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="
                          editMode ? $t('customer_message') : $t('your_message')
                        "
                        v-model="request.customerComments"
                        @input="updateCharacterCountCustomerComments"
                      ></v-textarea>
                      <div class="upload-limit-text">
                        <span
                          :style="{
                            color:
                              characterCountCustomerComments > 3000
                                ? 'red'
                                : 'inherit',
                          }"
                        >
                          {{ characterCountCustomerComments }}</span
                        >
                        /{{ 3000 }} {{ $t("characters") }}
                        <div
                          v-if="characterCountCustomerComments > 3000"
                          style="color: red"
                        >
                          {{ $t("characterExceeded") }}
                        </div>
                        <!-- {{ characterCountCustomerComments }} /3000
                        {{ $t("characters") }} -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 disablerow C-I-wrapper">
                    <div class="col-md-12 pt-0 margin-wrapper">
                      <span class="headlinecolor formheading">
                        {{ $t("training_details") }}</span
                      >
                    </div>
                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('vehicle')"
                        v-model="request.vehicle"
                      ></v-text-field>
                    </div>
                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('productNumber')"
                        v-model="request.productNumber"
                      ></v-text-field>
                    </div>
                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('productGroup')"
                        v-model="request.productGroup"
                      ></v-text-field>
                    </div>
                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('projectNumber')"
                        v-model="request.projectNumber"
                      ></v-text-field>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <v-select
                        hide-details="auto"
                        :items="$selectableLanguages"
                        item-value="key"
                        item-text="translatedName"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('language') + '*'"
                        v-model="request.language"
                      ></v-select>
                    </div>
                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        type="number"
                        min="1"
                        outlined
                        :label="$t('trainingAmountNeeded') + '*'"
                        v-model="request.trainingAmountNeeded"
                      ></v-text-field>
                    </div>
                    <div class="col-12" id="trainingRequestDocument">
                      <Upload
                        v-model="request.trainingDocumentList"
                        multiple
                        allowOtherFileTypes
                        uploadPublic
                      />
                      <div>{{ $t("max_size_1000mb") }}</div>
                    </div>
                  </div>
                  <div class="col-md-6 disablerow C-I-wrapper" v-if="editMode">
                    <div class="col-md-12 pt-0 margin-wrapper">
                      <span class="headlinecolor formheading">
                        {{ $t("additional_information") }}</span
                      >
                    </div>
                    <div class="col-12">
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        type="number"
                        :min="1"
                        :rules="[positiveNumberRule]"
                        :label="$t('preparation_time_in_days') + '*'"
                        v-model="request.preparationTimeInDays"
                      ></v-text-field>
                    </div>
                    <div class="col-md-12 further-info-overholding-wrap">
                      <v-checkbox
                        v-model="request.overhaulingTraining"
                        class="no-margin-top"
                        :label="$t('overhauling_training')"
                        :hint="$t('overhauling_training_hint')"
                      ></v-checkbox>
                    </div>
                    <div class="col-md-12 pb-4">
                      <v-textarea
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('comment')"
                        v-model="request.comments"
                        @input="updateCharacterCountComments"
                      ></v-textarea>
                      <div class="upload-limit-text-1">
                        <span
                          :style="{
                            color:
                              characterCountComments > 6000 ? 'red' : 'inherit',
                          }"
                        >
                          {{ characterCountComments }}</span
                        >
                        /{{ 6000 }} {{ $t("characters") }}
                        <div
                          v-if="characterCountComments > 6000"
                          style="color: red"
                        >
                          {{ $t("characterExceeded") }}
                        </div>
                        <!-- {{ characterCountComments }} /3000 {{ $t("characters") }} -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 disablerow C-I-wrapper" v-if="editMode">
                    <div class="col-md-12 pt-0 margin-wrapper">
                      <span class="headlinecolor formheading">
                        {{ $t("logistics_by_customer") }}</span
                      >
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <v-select
                        hide-details="auto"
                        :items="infrastructures"
                        item-value="value"
                        item-text="text"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        multiple
                        clearable
                        :label="$t('needed_infrastructures')"
                        v-model="request.neededInfrastructure"
                      ></v-select>
                    </div>
                    <div
                      class="col-12"
                      v-show="request.neededInfrastructure.includes('OTHER')"
                    >
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('additional_needed_infrastructure')"
                        v-model="request.additionalNeededInfrastructure"
                      ></v-text-field>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <v-select
                        hide-details="auto"
                        :items="toolsAndMaterials"
                        item-value="value"
                        item-text="text"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        multiple
                        clearable
                        :label="$t('needed_tools_and_materials')"
                        v-model="request.neededToolsAndMaterials"
                      ></v-select>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <v-select
                        hide-details="auto"
                        :items="vehicles"
                        item-value="value"
                        item-text="text"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        multiple
                        clearable
                        :label="$t('needed_vehicles')"
                        v-model="request.neededVehicles"
                      ></v-select>
                    </div>
                    <div
                      class="col-12"
                      v-show="request.neededVehicles.includes('OTHER')"
                    >
                      <v-text-field
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('additional_needed_vehicles')"
                        v-model="request.additionalNeededVehicles"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="col-md-6 disablerow C-I-wrapper" v-if="editMode">
                    <div class="col-md-12 pt-0 margin-wrapper">
                      <span class="headlinecolor formheading">
                        {{ $t("Admin_Use") }}</span
                      >
                    </div>
                    <div class="col-12">
                      <v-select
                        hide-details="auto"
                        :items="sortedCountriesLocation"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('country') + '*'"
                        v-model="request.locationcountry"
                      ></v-select>
                    </div>
                    <div class="col-12">
                      <v-autocomplete
                        v-model="request.locationManager"
                        hide-details="auto"
                        class="datainput justify-content-end searchbar align-self-center pb-1"
                        :items="computedLocationManager"
                        item-text="text"
                        item-value="value"
                        style="padding-right: 2px"
                        dense
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        :label="$t('location_manager')"
                      >
                      </v-autocomplete>
                    </div>
                    <!-- <div class="col-12">
                      <v-autocomplete
                        v-model="request.trainers"
                        hide-details="auto"
                        class="datainput justify-content-end searchbar align-self-center pb-1"
                        :items="trainers"
                        item-text="text"
                        item-value="value"
                        multiple
                        style="padding-right: 2px"
                        dense
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        :label="$t('trainers')"
                        @change="onTrainerChange"
                      >
                      </v-autocomplete>
                    </div> -->
                  </div>

                  <div class="col-md-12 further-info-overholding-wrap">
                    <v-checkbox
                      v-model="consentprivacy"
                      class="no-margin-top"
                      hide-details="auto"
                      v-show="!editMode"
                    >
                      <template v-slot:label>
                        <v-span
                          >{{ $t("agree_privacy_policy2_part1") }}
                          <a
                            :href="`/files/images/KB_DS-Hinweise_knorr-bremse.com_DE_20220310_Website_${$locale}.pdf`"
                            target="_blank"
                            @click.stop
                          >
                            {{ $t("agree_privacy_policy2_part2") }}</a
                          >
                          {{ $t("agree_privacy_policy2_part3") }}</v-span
                        >
                      </template>
                    </v-checkbox>
                  </div>
                  <div class="col-md-12 lastBtnSubmit">
                    <v-btn
                      v-show="!editMode"
                      @click="sendRequest()"
                      outlined
                      depressed
                      tile
                      class="savebutton mr-2 mb-2"
                      >{{ $t("send_request") }}</v-btn
                    >

                    <v-btn
                      v-show="
                        editMode && $rights.includes('EDIT_TRAINING_REQUESTS')
                      "
                      @click="sendRequest()"
                      outlined
                      depressed
                      tile
                      class="savebutton mr-2 mb-2"
                      >{{ $t("save") }}</v-btn
                    >
                    <v-btn
                      @click="$routerBack()"
                      outlined
                      depressed
                      tile
                      class="cancelBtn-1 mr-2 mb-2"
                      >{{ $t("cancel") }}</v-btn
                    >
                    <v-btn
                      v-show="
                        editMode && $rights.includes('DELETE_TRAINING_REQUESTS')
                      "
                      @click="openDeleteDialog = true"
                      outlined
                      depressed
                      tile
                      class="deletebutton cancelBtn-1 mr-2 mb-2"
                    >
                      <v-icon color="#444">mdi-delete</v-icon>
                      {{ $t("delete") }}</v-btn
                    >
                  </div>
                </div>

                <!--  -->
                <div class="text-center">
                  <v-dialog v-model="openDeleteDialog" width="500">
                    <h4>{{ $t("confirm_delete_TrainingRequest") }}</h4>
                    <v-card-actions class="align_center">
                      <v-btn
                        @click="openDeleteDialog = false"
                        outlined
                        depressed
                        tile
                        class="cancelBtn mr-2 mb-2"
                      >
                        {{ $t("cancel") }}</v-btn
                      >
                      <v-btn
                        @click="deleteRequest()"
                        outlined
                        depressed
                        tile
                        class="savebutton mb-2"
                      >
                        <img
                          src="/static/img/popup-delete-icon.svg"
                          class="popup-delete-icon"
                        />
                        {{ $t("delete") }}</v-btn
                      >
                    </v-card-actions>
                  </v-dialog>
                </div>

                <!--  -->
                <div class="text-right mb-1">
                  <v-label> * {{ $t("mandatory_fields") }} </v-label>
                </div>
              </v-tab-item>

              <!-- Tab For Training Events -->
              <v-tab-item v-if="$user && !$user.onlySalesPerson">
                <div class="px-md-4 mx-0 pa-0 text-content">
                  <v-simple-table
                    class="trainingstable"
                    style="width: 100%"
                    hide-default-footer
                  >
                    <thead>
                      <tr>
                        <th
                          @click="
                            (sort = 'training.id'),
                              (order = !order),
                              (page = 1),
                              fetchTrainingEvents()
                          "
                          class="text-uppercase align-center table-trainer-wrapper-head"
                        >
                          {{ $t("training") }}
                          <v-icon v-show="sort == 'training.id' && order"
                            >fas fa-chevron-down</v-icon
                          ><v-icon v-show="sort == 'training.id' && !order"
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                        <th
                          @click="
                            (sort = 'startDate'),
                              (order = !order),
                              (page = 1),
                              fetchTrainingEvents()
                          "
                          class="text-uppercase align-center table-trainer-wrapper-head"
                        >
                          {{ $t("date") }}
                          <v-icon v-show="sort == 'startDate' && order"
                            >fas fa-chevron-down</v-icon
                          ><v-icon v-show="sort == 'startDate' && !order"
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                        <th
                          @click="
                            (sort = 'room.location.id'),
                              (order = !order),
                              (page = 1),
                              fetchTrainingEvents()
                          "
                          class="text-uppercase align-center table-trainer-wrapper-head"
                        >
                          {{ $t("location") }}
                          <v-icon v-show="sort == 'room.location.id' && order"
                            >fas fa-chevron-down</v-icon
                          ><v-icon v-show="sort == 'room.location.id' && !order"
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                        <th
                          class="text-uppercase align-center table-trainer-wrapper-head"
                        >
                          {{ $t("free_spaces") }}
                        </th>
                        <th
                          @click="
                            (sort = 'status'),
                              (order = !order),
                              (page = 1),
                              fetchTrainingEvents()
                          "
                          class="text-uppercase align-center table-trainer-wrapper-head"
                        >
                          {{ $t("type") }}
                          <v-icon v-show="sort == 'status' && order"
                            >fas fa-chevron-down</v-icon
                          ><v-icon v-show="sort == 'status' && !order"
                            >fas fa-chevron-up</v-icon
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="trainingEvent in trainingEvents"
                        :key="trainingEvent.id"
                        @click="
                          $router.push(
                            '/edit-training-event?trainingEventId=' +
                              trainingEvent.id
                          )
                        "
                      >
                        <td
                          v-if="trainingEvent.training"
                          class="pb-1 text-uppercase align-center"
                        >
                          {{ trainingEvent.training.designationsMap[$locale] }}
                        </td>
                        <td
                          v-else-if="trainingEvent.trainingEventCategory"
                          class="pb-1 text-uppercase align-center"
                        >
                          {{
                            trainingEvent.trainingEventCategory.designationsMap[
                              $locale
                            ]
                          }}
                        </td>
                        <td
                          v-else
                          class="pb-1 text-uppercase align-center"
                        ></td>
                        <td
                          class="pb-1 text-uppercase align-center"
                          v-html="designationsFieldDate(trainingEvent)"
                        ></td>
                        <td
                          class="pb-1 text-uppercase align-center"
                          v-html="locationfiled(trainingEvent)"
                        ></td>
                        <td class="pb-1 text-uppercase align-center">
                          {{ trainingEvent.freeSpaces }}
                        </td>
                        <td class="pb-1 text-uppercase align-center">
                          {{ $t(trainingEvent.status) }}
                        </td>
                      </tr>
                      <tr v-show="trainingEvents.length == 0">
                        <td
                          class="pb-1 text-uppercase align-center"
                          colspan="6"
                        >
                          {{ $t("no_trainingEvents") }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <pagination
                    class="my-2"
                    :current-page="events_page"
                    :total-pages="events_totalPages"
                    :show-previous-page="events_previousPage"
                    :show-next-page="events_nextPage"
                  ></pagination>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>

        <!-- Right Area -->
        <div
          class="col-xl-3 px-0 pl-8 pl-8 pl-md-12 pl-lg-8 row pt-0 onlyContact"
        >
          <div class="col-xl-12 right-side-block" v-show="editMode">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              v-show="
                editMode && $rights.includes('DOWNLOAD_TRAINING_REQUESTS')
              "
              @click="download()"
              outlined
              depressed
              tile
              class="downBtn savebutton mr-2 mb-2"
            >
              <v-icon class="download-icon" color="#444" small
                >fas fa-file-pdf</v-icon
              >
              {{ $t("downloadpdf") }}</v-btn
            >

            <v-btn
              v-show="editMode && $rights.includes('CREATE_SALESLIST')"
              @click="salesList()"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              v-if="!request.salesList"
            >
              {{ $t("create-sales-list") }}</v-btn
            >

            <v-btn
              v-show="editMode && $rights.includes('VIEW_SALESLIST')"
              @click="salesList()"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              v-else
            >
              {{ $t("view-sales-list") }}</v-btn
            >
          </div>
          <div
            class="col-xl-12 right-side-block"
            v-show="
              request.customerTenant == null &&
              $rights.includes('CREATE_CUSTOMERS')
            "
          >
            <h3>{{ $t("customer") }}</h3>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              @click="createTenant()"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              >{{ $t("create_tenant") }}</v-btn
            >
            <!-- <v-btn
              @click="createTrainingEvent()"
              v-show="request.customerTenant != null  &&  $rights.includes('CREATE_TRAINING_EVENT')"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              >{{ $t("create_trainingEvent") }}</v-btn
            > -->
          </div>
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  props: {
    trainingId: Number,
    trainingRequestId: Number,
    eventTrainingCategoryId: Number,
  },

  data() {
    return {
      positiveNumberRule: (value) => {
        return value >= 0 || this.$t("Please_Enter_number");
      },
      users: [],
      trainingEventCategories: [],
      //trainers: [],
      location: null,
      trainings: [],
      countries: [],
      infrastructures: [
        { value: "TRAINING_ROOM", text: this.$t("training_room") },
        { value: "PROJECTOR", text: this.$t("projector") },
        { value: "FLIPCHART", text: this.$t("flipchart") },
        { value: "OTHER", text: this.$t("other") },
      ],
      toolsAndMaterials: [
        { value: "SPARE", text: this.$t("spare") },
        { value: "SPECIALTOOLS", text: this.$t("specialtools") },
        { value: "OPK", text: this.$t("opk") },
        {
          value: "CUSTOMER_DOCUMENTATION",
          text: this.$t("customer_documentation"),
        },
        { value: "TEST_BED", text: this.$t("test_bed") },
        { value: "BR_PROTOCOL", text: this.$t("br_protocol") },
      ],
      vehicles: [
        { value: "VEHICLE", text: this.$t("vehicle") },
        { value: "WORKSHOP_PIT", text: this.$t("workshop_pit") },
        {
          value: "SWITCHING_AUTHORISATION",
          text: this.$t("switching_authorisation"),
        },
        { value: "OTHER", text: this.$t("other") },
      ],

      trainingEvents: [],
      events_page: 1,
      events_totalPages: 1,
      events_ElementPerPage: 50,
      events_sort: null,
      events_order: true,

      editMode: false,
      openDeleteDialog: false,

      consentprivacy: false,

      trainingRequestTab: null,
      characterCountCustomerComments: 0,
      trainingEventCategories: null,
      characterCountComments: 0,
      locationCountry: true,
      request: {
        eventTrainingCategoryId: null,
        trainers: "",
        locationManager: null,
        locationcountry: null,
        firstname: null,
        lastname: null,
        phone: null,
        email: null,
        customerName: null,
        customerLocation: null,
        customerNumber: null,
        documentType: "ONLINE",
        street: null,
        hnr: null,
        zip: null,
        city: null,
        country: null,
        trainingId: null,
        vehicle: null,
        productNumber: null,
        productGroup: null,
        projectNumber: null,
        language: null,
        otherTraining: null,
        trainingAmountNeeded: null,
        contactPerson: null,
        location: null,
        customerComments: null,
        infrastructure: null,
        participantsAmount: null,
        participantQualification: null,
        customerComments: null,
        preparationTimeInDays: null,
        neededInfrastructure: [],
        additionalNeededInfrastructure: null,
        neededToolsAndMaterials: [],
        neededVehicles: [],
        additionalNeededVehicles: null,
        comments: null,
        overhaulingTraining: false,
        trainingDocumentList: [],
      },
      trainingDisabled: false,
      trainingCategoryDisabled: false,
      showCategory: false,
      isLoad: false,
      countriesLocation: [],
    };
  },
  watch: {
    filteredCategories: {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },
    request: {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },
  },
  computed: {
 
    computedLocationManager() {
      return this.users;
    },
    filteredCategories() {
      if (this.request.eventTrainingCategoryId) {
        // Return the filtered categories based on the selected ID
        const filteredCategories = [];
        for (const catGroup of this.trainingEventCategories) {
          if (catGroup.id === this.request.eventTrainingCategoryId) {
            for (const cat of catGroup.category) {
              if (
                cat.designationMap[this.$locale] != null ||
                cat.designationMap[this.$locale] != ""
              ) {
                filteredCategories.push({
                  value: cat.id,
                  text: cat.designationMap[this.$locale],
                });
              }
            }
          }
        }
        return filteredCategories;
      }
    },
    trainingEventCategories1() {
      const trainingEventCategories = Array.isArray(
        this.trainingEventCategories
      )
        ? this.trainingEventCategories
            .filter(
              (trainingEventCategory) =>
                trainingEventCategory.designationsMap[this.$locale]
            ) // filter out invalid entries
            .map((trainingEventCategory) => ({
              value: trainingEventCategory.id,
              text: trainingEventCategory.designationsMap[this.$locale],
            }))
        : [];

      return trainingEventCategories;
    },
    sortedCountries() {
      return this.countries
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
    sortedCountriesLocation() {
      return this.countriesLocation
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
    sortedTrainings() {
      return this.trainings.sort((a, b) => {
        const textA = a.text ? a.text.trim().toLowerCase() : "";
        const textB = b.text ? b.text.trim().toLowerCase() : "";
        return textA.localeCompare(textB, this.$locale, {
          sensitivity: "base",
        });
      });

      // return this.trainings.sort((a, b) => a.text.trim().toLowerCase().localeCompare(b.text,this.$locale, { sensitivity: 'base' }));
    },
  },

  mounted() {
    if (
      this.isLoad != true &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    }
    this.fetchTrainings();
    this.fetchCategory();
    this.fetchCountries();
    this.fetchCountriesLocation();
    if (this.trainingId != null)
      this.request.trainingId = parseInt(this.trainingId);

    if (this.trainingRequestId != null) {
      this.editMode = true;
      this.fetchEditingTrainingRequest();
    }

    if (this.$route.query.eventTrainingCategoryId) {
      const id = this.$route.query.eventTrainingCategoryId;
      this.request.eventTrainingCategoryId = parseInt(id, 10);
    }
    if (this.editMode) {
      this.fetchAllLocationManagers();
      //this.fetchTrainers();
    }
  },

  methods: {
    designationsFieldDate(params) {
      if (params.eventNumber) {
        if (params.startDate) {
          return `<div class="event-start-date">${params.startDateFormatted}</div><div class="practical_theoretical_wrap">${params.daysFormatted}</div> `;
        }
        if (
          params.startDate_PR_1 ||
          params.startDate_PR_2 ||
          params.startDate_PR_3 ||
          params.startDate_TH_1 ||
          params.startDate_TH_2 ||
          params.startDate_TH_3
        ) {
          let formattedDates = "";

          if (params.startDate_TH_1) {
            formattedDates += `<div class="event-start-date">${params.startDateFormatted_TH_1}</div><div class="practical_theoretical_wrap">${params.daysFormatted_TH_1}</div>`;
          }

          if (params.startDate_TH_2) {
            formattedDates += `<div class="event-start-date">${params.startDateFormatted_TH_2}</div><div class="practical_theoretical_wrap">${params.daysFormatted_TH_2}</div>`;
          }

          if (params.startDate_TH_3) {
            formattedDates += `<div class="event-start-date">${params.startDateFormatted_TH_3}</div><div class="practical_theoretical_wrap">${params.daysFormatted_TH_3}</div>`;
          }
          if (params.startDate_PR_1) {
            formattedDates += `<div class="event-start-date">${params.startDateFormatted_PR_1}</div><div class="practical_theoretical_wrap">${params.daysFormatted_PR_1}</div>`;
          }

          if (params.startDate_PR_2) {
            formattedDates += `<div class="event-start-date">${params.startDateFormatted_PR_2}</div><div class="practical_theoretical_wrap">${params.daysFormatted_PR_2}</div>`;
          }

          if (params.startDate_PR_3) {
            formattedDates += `<div class="event-start-date">${params.startDateFormatted_PR_3}</div><div class="practical_theoretical_wrap">${params.daysFormatted_PR_3}</div>`;
          }

          return formattedDates; // Return the formatted dates as a single HTML string
        }
      }
    },

    locationfiled(params) {
      if (params.locationFormatted) {
        return `<div style="font-size: 14px; line-height: 20px; color: #5b5b5b; padding-bottom: 5px;">${params.locationFormatted}</div>`;
      }

      if (
        params.locationFormatted_PR_1 ||
        params.locationFormatted_PR_2 ||
        params.locationFormatted_PR_3 ||
        params.locationFormatted_TH_1 ||
        params.locationFormatted_TH_2 ||
        params.locationFormatted_TH_3
      ) {
        let formattedLocation = "";
        if (params.locationFormatted_PR_1) {
          formattedLocation += `<div>${params.locationFormatted_PR_1}</div>`;
        }

        if (params.locationFormatted_PR_2) {
          formattedLocation += `<div>${params.locationFormatted_PR_2}</div>`;
        }

        if (params.locationFormatted_PR_3) {
          formattedLocation += `<div>${params.locationFormatted_PR_3}</div>`;
        }
        if (params.locationFormatted_TH_1) {
          formattedLocation += `<div>${params.locationFormatted_TH_1}</div>`;
        }

        if (params.locationFormatted_TH_2) {
          formattedLocation += `<div>${params.locationFormatted_TH_2}</div>`;
        }

        if (params.locationFormatted_TH_3) {
          formattedLocation += `<div>${params.locationFormatted_TH_3}</div>`;
        }
        return formattedLocation;
      }
    },
    fetchCountriesLocation() {
      this.$axios
        .get("/api/location/countries")
        .then((response) => {
          this.countriesLocation = response.data;
        })
        .catch(this.onError);
    },
    //  onTrainerChange(value) {
    //   if (value.length > 6) {
    //     this.request.trainers = value.slice(0, 6);
    //     this.$nextTick(() => {
    //       this.$forceUpdate();
    //     });
    //     this.$noty.error(this.$t('only_add_6_trainers'))
    //   } else {
    //     this.request.trainers = value;
    //   }
    // },
    // fetchTrainers() {
    //   var _this = this;
    //   progressIndicator.hidden = false;
    //   showLoadingCircle(true);
    //   this.$axios
    //     .get("/api/user/trainer")
    //     .then(function (response) {
    //       for (let i = 0; i < response.data.length; i++) {
    //         const element = response.data[i];
    //         if (Number.isInteger(element)) {
    //           _this.fetchSingleTrainerAndPush(element);
    //         } else {
    //           _this.trainers.push({
    //             text: element.fullname,
    //             value: element.id,
    //           });
    //         }
    //       }
    //     })
    //     .catch(this.onError)
    //     .finally(this.onFinally);
    // },

    // fetchSingleTrainerAndPush(trainerId) {
    //   var _this = this;
    //   progressIndicator.hidden = false;
    //   showLoadingCircle(true);
    //   this.$axios
    //     .get("/api/user/" + trainerId)
    //     .then(function (response) {
    //       const element = response.data;
    //       _this.trainers.push({ text: element.fullname, value: element.id });
    //     })
    //     .catch(this.onError)
    //     .finally(this.onFinally);
    // },
    fetchAllLocationManagers() {
      var _this = this;
      this.$axios
        .get("/api/user/locationManager")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (Number.isInteger(element)) {
              _this.fetchSingleLocationManagerAndPush(element);
            } else {
              _this.users.push({
                text: element.fullname,
                value: element.id,
                country: element.tenantLocation,
              });
            }
          }
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    fetchSingleLocationManagerAndPush(locationManagerId) {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/" + locationManagerId)
        .then(function (response) {
          const element = response.data;
          _this.users.push({
            text: element.fullname,
            value: element.id,
            country: element.tenantLocation,
          });
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    updateCharacterCountCustomerComments() {
      this.characterCountCustomerComments =
        this.request.customerComments.length;
    },
    updateCharacterCountComments() {
      this.characterCountComments = this.request.comments.length;
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    onFinally() {
      showLoadingCircle(false);
    },

    salesList() {
      if (this.request.salesList) {
        this.$router.push(
          "/sales-request?salesListId=" + this.request.salesList.id
        );
        return;
      }
      if (this.trainingRequestId) {
        if (this.locationCountry) {
          this.$noty.error(this.$t("please_addcounty_and_save"));
          return;
        }

        this.$router.push(
          "/sales-request?trainingRequestId=" + this.trainingRequestId
        );
        return;
      }
    },

    fetchTrainings() {
      var _this = this;
      showLoadingCircle(true);
      this.$axios
        .get("/api/training/trainings")
        .then(function (response) {

          const trainings = response.data;
           for (let i = 0; i < trainings.length; i++) {
            const training = trainings[i];
            if (
              training.trainingflag == "0" &&
              training.designationsMap[_this.$locale]
            ) {
              _this.trainings.push({
                text: training.designationsMap[_this.$locale],
                value: training.id,
              });
            }
        }
          _this.$forceUpdate();
          showLoadingCircle(false);
        })
        .catch(this.onError);
    },

    fetchCategory() {
      var _this = this;
      this.$axios
        .get("/api/eventTrainingCategory")
        .then(function (response) {
          _this.trainingEventCategories = response.data.content;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchEditingTrainingRequest() {
      var _this = this;
      this.$axios
        .get("/api/training/request/" + this.trainingRequestId)
        .then(function (response) {
          _this.request = response.data;

          if (response.data.comments !== null) {
            _this.characterCountComments = response.data.comments.length;
          }
          if (response.data.customerComments !== null) {
            _this.characterCountCustomerComments =
              response.data.customerComments.length;
          }
          _this.$set(
            _this.request,
            "eventTrainingCategoryId",
            response.data.eventCategory != null
              ? response.data.eventCategory.id
              : null
          );

          _this.request.trainingId = response.data.training
            ? response.data.training.id
            : null;

          _this.$set(
            _this.request,
            "trainingId",
            response.data.training ? response.data.training.id : null
          );

          _this.trainingEvents = response.data.trainingEvents;

          //  let trainers = [];
          //   if (response.data.trainers != null) {

          //     for (let i = 0; i < response.data.trainers.length; i++) {
          //       if (response.data.trainers[i] && response.data.trainers[i].id) {
          //        trainers.push(response.data.trainers[i].id);
          //       }
          //     }
          //   }
          //  _this.$set(_this.request, 'trainers', response.data.trainers != null ? trainers : null);

          if (response.data.locationManager != null) {
            _this.request.locationManager = response.data.locationManager.id;
          }

          if (_this.trainingEvents.length > 0) _this.trainingRequestTab = 1;

          if (_this.request.eventTrainingCategoryId) {
            _this.trainingDisabled = true;
            _this.showCategory = true;
            _this.request.trainingId = null;
          } else if (_this.request.trainingId) {
            _this.trainingCategoryDisabled = true;
            _this.showCategory = false;
            _this.request.eventTrainingCategoryId = null;
          }
          _this.$set(
            _this,
            "locationCountry",
            response.data.locationcountry ? false : true
          );
          //_this.locationCountry = !!response.data.locationcountry;

          //  _this.locationCountry =  response.data.locationcountry  ?  false : true;
          this.getSalesList();
        })
        .catch(this.onError);
    },
    getSalesList() {
      var _this = this;
      this.$axios
        .get("/api/saleslist/" + this.salesListId)
        .then(function (response) {
          _this.salesListCountry = response.data.country;
          if (_this.salesListCountry == this.$user.isOnlySalesPersonContry) {
            this.isOnlySalesPersonContryDisplay = true;
          }
        })
        .catch(this.onError);
    },

    fetchCountries() {
      this.$axios
        .get("/api/location/allCountries")
        .then((response) => {
          this.countries = response.data;
        })
        .catch(this.onError);
    },

    deleteRequest() {
      if (this.request.id == null) {
        console.error(
          "You are not editing an existing training course request."
        );
        return;
      }

      var _this = this;

      this.$axios
        .delete("/api/training/request/" + this.request.id)
        .then(function (response) {
          _this.$noty.success(_this.$t("request_deleted"));
          _this.$router.push("/training-requests");
        })
        .catch(this.onError);
    },
    validateRequest(request) {
      const missingFields = [];

      if (
        !request.otherTraining &&
        !request.trainingId &&
        !request.eventTrainingCategoryId
      ) {
        missingFields.push(this.$t("training"));
        missingFields.push(this.$t("training_event_category"));
      }

      if (missingFields.length > 0) {
        this.$noty.error(
          this.$t("empty_values", {
            name: this.$t("other_training"),
            name2: missingFields.join(", "),
          })
        );
        return false; // Indicating the validation failed
      }

      return true; // Indicating the validation passed
    },

    sendRequest(silent = false, afterFunction = null) {
      var _this = this;
      if (!_this.editMode) {
        if (typeof window.clarity !== "undefined") {
          window.clarity("event", "TrainingRequest Access");
        }
      }
      var request = {};
      request = Object.assign(request, this.request);
      let trainerArray = [];

      // if (request.trainers != null) {
      //   for (let i = 0; i < request.trainers.length; i++) {
      //     if (Number.isInteger(request.trainers[i])) {
      //       trainerArray.push(request.trainers[i]);
      //     }
      //   }
      // }

      // if (request.locationManager != null) {
      //   // for (let i = 0; i < request.locationManager.length; i++) {
      //   //   if (Number.isInteger(request.locationManager[i])) {
      //   //     locationManagerArray.push(request.locationManager[i]);
      //   //   }
      //   // }
      // }
      //  request.trainers = trainerArray;

      // request.locationManager = locationManagerArray;
      if (request.comments !== null) {
        request.comments = this.$convertHtml(request.comments);
      }
      if (request.customerComments !== null) {
        request.customerComments = this.$convertHtml(request.customerComments);
      }
      if (request.eventTrainingCategoryId) {
        request.eventTrainingCategoryId = request.eventTrainingCategoryId;
      }

      if (this.editMode && this.trainingRequestId)
        request.id = this.trainingRequestId;

      // Training oder Anderes Training muss vorhanden seinen
      if (!this.validateRequest(this.request)) {
        return; // Stop execution if validation fails
      }

      if (this.$isStringEmptyOrNull(request.firstname)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("firstname") })
        );
        return;
      }
      if (this.$isStringEmptyOrNull(request.lastname)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("lastname") }));
        return;
      }

      // const phoneRegex = /^\+?[0-9\s\-()/]+$/;
      if (this.$isStringEmptyOrNull(request.phone)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("phone") }));
        return;
      }

      // if(!phoneRegex.test(request.phone)){
      //   this.$noty.error(this.$t("invalid_value", { name: this.$t("phone") }));
      //   return;
      // }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.$isStringEmptyOrNull(request.email)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("email") }));
        return;
      } else if (!emailRegex.test(request.email)) {
        this.$noty.error(this.$t("invalid_value", { name: this.$t("email") }));
        return;
      }

      if (this.$isStringEmptyOrNull(request.customerName)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("company") }));
        return;
      }

      if (this.$isStringEmptyOrNull(request.customerLocation)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("customer_location") })
        );
        return;
      }

      if (this.$isStringEmptyOrNull(request.street)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("street") }));
        return;
      }

      if (this.$isStringEmptyOrNull(request.hnr)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("number") }));
        return;
      }

      if (this.$isStringEmptyOrNull(request.zip)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("postal code") })
        );
        return;
      }
      if (this.$isStringEmptyOrNull(request.city)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("location") }));
        return;
      }

      if (this.$isStringEmptyOrNull(request.country)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("country") }));
        return;
      }
      if (this.$isStringEmptyOrNull(request.contactPerson)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("contactPerson") })
        );
        return;
      }
      if (this.$isStringEmptyOrNull(request.documentType)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("documents in") })
        );
        return;
      }
      if (this.$isStringEmptyOrNull(request.location)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("training_location") })
        );
        return;
      }

      if (!request.participantsAmount) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("participantsAmount") })
        );
        return;
      } else if (request.participantsAmount <= 0) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("participantsAmount") })
        );
        return;
      }

      if (this.$isStringEmptyOrNull(request.participantQualification)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("participantQualification") })
        );
        return;
      }

      if (this.$isStringEmptyOrNull(request.language)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("language") }));
        return;
      }
      if (!request.trainingAmountNeeded) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("trainingAmountNeeded") })
        );
        return;
      } else if (request.trainingAmountNeeded <= 0) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("trainingAmountNeeded") })
        );
        return;
      }

      if (this.characterCountCustomerComments > 3000) {
        this.$noty.error(
          this.$t("character_exceeded", { name: this.$t("customer_message") })
        );
        return;
      }
      if (this.characterCountComments > 6000) {
        this.$noty.error(
          this.$t("character_exceeded", { name: this.$t("comment") })
        );
        return;
      }

      // if (request.trainers != null) {
      //   request.trainers = request.trainers.join(";");
      // }
      // if (request.locationManager != null) {
      //   request.locationManager = request.locationManager.join(";");
      // }

      if (!this.editMode) {
        if (!this.consentprivacy) {
          this.$noty.error(this.$t("please_accept_privacy_policy"));
          return;
        }
      }
      if (this.editMode) {
        if (this.$isStringEmptyOrNull(request.locationcountry)) {
          this.$noty.error(
            this.$t("empty_value", { name: this.$t("country") })
          );
          return;
        }
        if (request.phone.length == 0) {
          this.$noty.error(this.$t("empty_value", { name: this.$t("phone") }));
          return;
        }
      }

      delete request.training;

      progressIndicator.hidden = false;
      showLoadingCircle(true);

      this.$axios
        .post("/api/training/request", request)
        .then(function (response) {
          if (!silent) {
            if (_this.editMode) {
              _this.$noty.success(_this.$t("request_edited"));
              _this.$router.push("/training-requests");
            } else {
              _this.$noty.success(_this.$t("request_sent"));
              _this.$router.push("/");
            }
          }
          if (afterFunction != null) afterFunction();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    createTenant() {
      if (this.trainingRequestId == null) return;
      var _this = this;
      this.sendRequest(true, function () {
        _this.$axios
          .post(
            "/api/training/request/" +
              _this.trainingRequestId +
              "/create-tenant"
          )
          .then(function (response) {
            const customerName =
              _this.request.customerLocation == null
                ? _this.request.customerName
                : _this.request.customerName +
                  " " +
                  _this.request.customerLocation;
            _this.$noty.success(
              _this.$t("tenant_saved", { name: customerName })
            );
            _this.fetchEditingTrainingRequest();
          })
          .catch(_this.onError);
      });
    },

    createTrainingEvent() {
      if (this.trainingRequestId == null) return;
      this.$router.push(
        "/create-training-event?trainingRequestId=" + this.trainingRequestId
      );
    },
    download() {
      if (this.trainingRequestId == null) return;
      var _this = this;
      this.$axios
        .get("/api/training/request/" + _this.trainingRequestId + "/download", {
          responseType: "blob",
        })
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "training_request_" + _this.trainingRequestId + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    disableTraining() {
      if (this.request.eventTrainingCategoryId) {
        this.trainingDisabled = true;
        this.showCategory = true;
        this.request.trainingId = null;
      } else {
        this.trainingDisabled = false;
      }
    },
    disableTrainingEventCategory() {
      if (this.request.trainingId) {
        this.trainingCategoryDisabled = true;
        this.request.eventTrainingCategoryId = null;
        this.showCategory = false;
      } else {
        this.trainingCategoryDisabled = false;
      }
    },
  },
};
</script>
